/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CorePresignedUploadResponseDto } from '../../models/core-presigned-upload-response-dto';
import { CoreRequestUploadUrlDto } from '../../models/core-request-upload-url-dto';

export interface DocumentsControllerGenerateUploadUrls$Params {

/**
 * Tenant identifier for multi-tenancy isolation.
 */
  tenant: string;
      body: CoreRequestUploadUrlDto
}

export function documentsControllerGenerateUploadUrls(http: HttpClient, rootUrl: string, params: DocumentsControllerGenerateUploadUrls$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, documentsControllerGenerateUploadUrls.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CorePresignedUploadResponseDto>>;
    })
  );
}

documentsControllerGenerateUploadUrls.PATH = '/o2-core/documents/{tenant}/subtask-attachments/upload-url';
